import { Grid, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  display: "flex",
  gap: "10px",
  justifyContent: "end",
});

export const RemoveButton = styled(IconButton)(({ theme }) => ({
  opacity: 0.5,
  "&:hover": {
    opacity: 1,
  },
}));
